/**
 * Feature 100 — shown when an expired trial FP hits the platform (routed here
 * by the apiClient on a TRIAL_EXPIRED 403). Data is retained; the account can
 * be extended or converted by the bQuest team.
 */

import { Clock } from 'lucide-react';
import { Card } from '@/shared/components/ui/card';

export function TrialEndedPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="p-10 max-w-lg text-center">
        <Clock className="w-12 h-12 text-[#a67c1a] mx-auto mb-4" aria-hidden="true" />
        <h1 className="text-2xl text-gray-900 mb-3">Your trial has ended</h1>
        <p className="text-gray-600 mb-2">
          Thanks for exploring bQuest! Your 7-day Advisor Trial is complete, and everything you
          built — clients, care guides, referrals — is safely saved.
        </p>
        <p className="text-gray-600 mb-2">
          Contact your bQuest representative to activate your account and pick up right where you
          left off.
        </p>
        <p className="text-gray-600">
          Questions? Reach us at{' '}
          <a href="mailto:info@thebquest.com" className="text-[#026857] font-medium hover:underline">
            info@thebquest.com
          </a>
          .
        </p>
      </Card>
    </div>
  );
}
